export interface DashboardMonth {
  year: number;
  month: number;
  label: string;
}

// Coerce the NSwag-optional AvailableMonth fields into a guaranteed shape once, at the data
// boundary, so monthKey and the rest stay strict and honest downstream. Shared by every tab
// that reads the available-months list so they normalize identically.
export const normalizeMonths = (raw: ({ year?: number; month?: number; label?: string } | undefined)[] | undefined): DashboardMonth[] =>
  (raw ?? [])
    .map((m) => ({ year: m?.year ?? 0, month: m?.month ?? 0, label: m?.label ?? "" }))
    // Drop entries that lack a valid year/month rather than emitting "0-00" keys downstream.
    .filter((m) => m.year > 0 && m.month >= 1 && m.month <= 12);

// Zero-padded "yyyy-MM" — the backend trend parser requires exactly 7 chars.
export const monthKey = (m: { year: number; month: number }) => `${m.year}-${String(m.month).padStart(2, "0")}`;

// Only allow http(s) hrefs through. Guards against javascript:/data: URLs sneaking in from
// upstream (e.g. Bitbucket) data and executing on click; anything else renders link-less.
export const safeHttpUrl = (url: string | undefined): string | undefined => {
  if (!url) {
    return undefined;
  }
  try {
    const { protocol } = new URL(url);
    return protocol === "https:" || protocol === "http:" ? url : undefined;
  } catch {
    return undefined;
  }
};
